<cb-dialog
    class="flex-col"
    dialogHeading="{{ mode === edit ? 'Edit' : 'Add' }} Item"
    (cancelDialog)="cancel(true)"
    *cbWaitFor="mode"
>
    <form class="flex-col flex" #form="ngForm">
        <div *cbWaitFor="mappedItem">
            <cb-input
                name="itemId"
                label="Item #"
                [(ngModel)]="tempItem.itemNumber"
                type="number"
                [required]="true"
            >
            </cb-input>
            <cb-input
                name="description"
                label="Item Description"
                [(ngModel)]="tempItem.description"
                [required]="true"
            >
            </cb-input>
            @if (designerView) {
                <div>
                    <div class="flex-row">
                        <cb-design-scheme-line-status-checkbox [(ngModel)]="tempItem.statusId">
                        </cb-design-scheme-line-status-checkbox>
                        <span class="mat-body-2" style="align-self: center">
                            Completed by Designer
                        </span>
                    </div>
                    @if (mode === edit) {
                        <cb-text-area
                            name="comments"
                            label="Comment"
                            [required]="false"
                            [(ngModel)]="tempItem.comments"
                        >
                        </cb-text-area>
                    }
                </div>
            }
        </div>
    </form>
    <div actions *cbWaitFor="form">
        @if (mode === add) {
            <button
                mat-raised-button
                [disabled]="form.pristine || form.invalid"
                color="primary"
                (cbClick)="saveDialogItem()"
            >
                Save
            </button>
        }
        @if (mode === edit) {
            <button
                mat-raised-button
                [disabled]="form.pristine || form.invalid"
                color="primary"
                (cbClick)="saveDialogEditItem()"
            >
                Save
            </button>
        }
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
